import { Flex, Link } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import PerfilAcessoService from "../../../main/services/PerfilAcessoService";
import Tabela from '../../components/Tabela';
import { Link as ReactLink } from "react-router-dom";
import { isEmptyArray } from "formik";
import Loading from "../../components/Loading";
import { useAuthProvider } from '../../../Context/AuthProvider';

const ListaPerfilAcesso = () => {

    document.title = 'MCA - Perfis de Acesso'

    const _IsMounted = useRef(false);
    const { roleKeycloack } = useAuthProvider();
    const [columns] = useState([
        {
            Header: 'Perfil',
            accessor: 'descricao',
            Cell: (props => {
                const id = props.row.original.id;
                var descricao = props.value;
                if (descricao && descricao.length > 100) {
                    descricao = descricao.substring(0, 100) + "..."
                }
                return <Link title={props.value} as={ReactLink} to={"/perfil-acesso/" + id}>{descricao}</Link>
            })
        },
        {
            Header: 'Tipo de Órgão Externo',
            accessor: 'tipoOrgao',
            Cell: (props) => <span>{props.value || ""}</span>
        },
        {
            Header: 'Data Início',
            accessor: 'dataInicio',
            Cell: (props) => <span>{props.value || ""}</span>
        },
        {
            Header: 'Data de Término',
            accessor: 'dataFim',
            Cell: (props) => <span>{props.value || ""}</span>
        },
    ])
    const [data, setData] = useState([]);
    const [fixedData, setFixedData] = useState([]);
    const [filter] = useState('');
    const [loading, setLoading] = useState(true);
    const [nullData, setNullData] = useState(true);
    const [tiposOrgao, setTiposOrgao] = useState([]);

    useEffect(() => {
        setLoading(true)
        _IsMounted.current = true;
        fetchData();
        fetchTiposOrgao();

        return () => {
            _IsMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function fetchTiposOrgao() {
        PerfilAcessoService.listarTiposOrgao()
            .then(res => {
                if (_IsMounted.current) {
                    const options = res.data.map(t => ({ label: t.nome, value: t.id }));
                    setTiposOrgao(options);
                }
            })
            .catch(() => {})
    }

    function fetchData() {
        setLoading(true)
        PerfilAcessoService.pesquisarPerfilAcesso("", "", "")
            .then(res => {
                if (!isEmptyArray(res.data)) {
                    setNullData(false)
                }
                setData(res.data)
                setFixedData(res.data)
                setLoading(false)
            }).catch((error) => {
                console.warn(error)
                setLoading(false)
            })
    }

    return (
        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >
            <Flex w="100%"></Flex>

            {loading ? (
                <Loading />
            ) : (
                <Flex>
                    <Tabela
                        data={data}
                        loading={loading}
                        columns={columns}
                        setLoading={setLoading}
                        filter={filter}
                        setData={setData}
                        dataNull={nullData}
                        fixedData={fixedData}
                        placeholderFilter="Pesquise pelo Perfil de acesso"
                        entidade="perfil-acesso"
                        roleKeycloack={roleKeycloack}
                        tiposOrgao={tiposOrgao}
                    />
                </Flex>
            )}
        </Flex>
    )
}

export default ListaPerfilAcesso;
